<template>
  <v-card>
    <ApolloQuery
      :query="require('../graphql/queries/getUserIdentity.graphql')"
      :variables="{
        userId,
      }"
      :update="val => { data = val; values = val.getUserIdentity.identityFields.reduce((acc, item) => ({ ...acc, [item.key]: item.value }), {}); }"
    >
      <template v-slot="{ result: { error: kycError } }">
        <AppNotification
          v-if="kycError"
          :message="kycError.message"
        />
        <v-card-text v-if="data && data.getUserIdentity && data.getUserIdentity.identityFields">
          <v-list>
            <v-list-item
              v-for="item in data.getUserIdentity.identityFields"
              :key="item.key"
            >
              <p style="margin: 0">{{item.label}}:</p>
              <div v-if="item.mask && item.mask.mask">
                <template :item="item">
                  <imask-input
                    v-model="values[item.key]"
                    style="color: white;margin-left: 1rem;width: 100%;"
                    :placeholder="item.label"
                    :definitions="Object.entries(item.mask.mask[0].definitions).reduce((acc, [k, v]) => ({ ...acc, [k]: new RegExp(v)}), {})"
                    :mask="item.mask.mask.map(it => ({ mask: it.pattern, definitions: Object.entries(it.definitions).reduce((acc, [k, v]) => ({ ...acc, [k]: new RegExp(v)}), {}) }))"
                    :unmask="true"
                    @accept="onAccept"
                  />
                </template>
              </div>
              <input
                v-if="!item.mask || !item.mask.mask"
                v-model="values[item.key]"
                style="color: white;margin-left: 1rem;width: 100%;"
                :placeholder="item.label"
              />
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="onSubmit"
          >Save</v-btn>
          <v-btn
            color="error"
            text
            @click="onClose"
          >Cancel</v-btn>
        </v-card-actions>
      </template>
    </ApolloQuery>
  </v-card>
</template>

<script>
import AppNotification from '@/components/AppNotification.vue';
import { IMaskComponent } from 'vue-imask';

export default {
  components: {
    AppNotification,
    'imask-input': IMaskComponent,
  },
  data: () => ({
    values: {},
    data: [],
    onAccept: value => {
      console.log(value);
    },
  }),
  props: {
    userId: {
      type: Number,
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async onSubmit() {
      console.log(this.values);

      await this.$apollo.mutate({
        // eslint-disable-next-line global-require
        mutation: require('../graphql/mutations/updateUserIdentity.graphql'),
        variables: {
          userId: this.userId,
          identity: this.values,
        },
      });

      this.onClose();
    },
  },
};
</script>
